module.exports = __webpack_public_path__ + "img/256.fb6a8e7c.png";